import { Column, Entity, OneToMany, PrimaryGeneratedColumn, VersionColumn } from "typeorm";

@Entity('100Incharge_inchargeXref')
export class InchargeBoothXRefEntity {
  
    @PrimaryGeneratedColumn("increment",{name:'id'})
    Id:number;
    @Column("int",{
      nullable:true,
      name:"100InchargeBoothID"
    })
    InchargeBoothID :number;
    @Column("int",{
      nullable:true,
      name:"100InchargeUserID"
    })
    InchargeUserID:number;
    @Column("date",{
      nullable:true,
      name:"Dateupdated"
    })
    Dateupdated:string;
    @Column("varchar",{
      nullable: true,
      length:500,
      name:"Createdby"
    })
    Createdby:string;
    @Column("date",{
      nullable:true,
      name:"UpdatedDte"
    })
    UpdatedDte:string;
    @Column("varchar",{
      nullable: true,
      length:500,
      name:"UpdatedBy"
    })
    UpdatedBy:string;   
}